import React from 'react';
import {Link} from 'react-router-dom';
import { Nav, NavItem, NavLink } from 'reactstrap';

export default class Example extends React.Component {
  render() {
    return (
      <div>
        <Nav>
            <Link to='/'>
          <NavLink >Home</NavLink>
            </Link>
            <Link to='/about'>
          <NavLink >About</NavLink>
            </Link>
            <Link to='/menu'>
          <NavLink >Menu</NavLink>
            </Link>
            <Link to='/contact'>
          <NavLink >Contact</NavLink>
            </Link>
        </Nav>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Navy.js